import React, { useEffect, useState } from 'react';
import { Globe, List, X } from '@phosphor-icons/react';
import { BrandMark } from './BrandMark';

const LINKS = [
  { id: 'products', key: 'products' },
  { id: 'sites', key: 'sites' },
  { id: 'why', key: 'why' },
  { id: 'contact', key: 'contact' },
];

export function scrollToSection(id) {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function LandingHeader({ copy, lang, onToggleLang, onLogin }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 border-b transition-colors duration-300 ${
        scrolled || open ? 'border-[#D4AF37]/30 bg-[#F8F6F0]/95 backdrop-blur-md' : 'border-transparent bg-transparent'
      }`}
      data-testid="landing-navbar"
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:px-8">
        <a href="#top" onClick={(event) => { event.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} aria-label="Valhalla Corporations">
          <BrandMark tone={scrolled || open ? 'dark' : 'light'} />
        </a>

        <nav className="hidden items-center gap-9 lg:flex" aria-label="Principal">
          {LINKS.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => go(link.id)}
              className={`font-landing text-[0.8rem] font-medium uppercase tracking-[0.16em] transition-colors hover:text-[#D4AF37] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] ${
                scrolled ? 'text-[#0A0A0A]' : 'text-[#F8F6F0]'
              }`}
            >
              {copy.nav[link.key]}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            type="button"
            onClick={onToggleLang}
            className={`flex h-11 items-center gap-1.5 px-2 font-landing text-xs font-semibold uppercase tracking-widest transition-colors hover:text-[#D4AF37] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] ${
              scrolled || open ? 'text-[#0A0A0A]' : 'text-[#F8F6F0]'
            }`}
            aria-label={lang === 'es' ? 'Switch to English' : 'Cambiar a español'}
            data-testid="landing-lang-toggle"
          >
            <Globe size={16} /> {lang === 'es' ? 'EN' : 'ES'}
          </button>
          <button
            type="button"
            onClick={onLogin}
            className={`hidden h-11 border px-5 font-landing text-[0.75rem] font-semibold uppercase tracking-[0.14em] transition-colors sm:inline-flex sm:items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] ${
              scrolled
                ? 'border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-[#F8F6F0]'
                : 'border-[#F8F6F0]/60 text-[#F8F6F0] hover:bg-[#F8F6F0] hover:text-[#0A0A0A]'
            }`}
            data-testid="landing-login-btn"
          >
            {copy.nav.login}
          </button>
          <button
            type="button"
            onClick={() => go('contact')}
            className="hidden h-11 bg-gradient-to-b from-[#E2C15A] to-[#C39B22] px-5 font-landing text-[0.75rem] font-semibold uppercase tracking-[0.14em] text-[#0A0A0A] transition-transform hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0A0A0A] md:inline-flex md:items-center"
          >
            {copy.nav.cta}
          </button>
          <button
            type="button"
            onClick={() => setOpen((value) => !value)}
            className={`flex h-11 w-11 items-center justify-center lg:hidden ${scrolled || open ? 'text-[#0A0A0A]' : 'text-[#F8F6F0]'}`}
            aria-label="Menu"
            aria-expanded={open}
          >
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-[#D4AF37]/30 bg-[#F8F6F0] px-5 pb-6 pt-2 lg:hidden" aria-label="Principal móvil">
          {LINKS.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => go(link.id)}
              className="block w-full border-b border-[#0A0A0A]/10 py-4 text-left font-landing text-sm font-medium uppercase tracking-[0.16em] text-[#0A0A0A]"
            >
              {copy.nav[link.key]}
            </button>
          ))}
          <button
            type="button"
            onClick={onLogin}
            className="mt-5 h-12 w-full border border-[#0A0A0A] font-landing text-xs font-semibold uppercase tracking-[0.16em] text-[#0A0A0A]"
          >
            {copy.nav.login}
          </button>
        </nav>
      )}
    </header>
  );
}
